<template lang="pug">
.wrapper-benefit-item(v-if="perm")
  a.recurso-outer(:href="perm.url" v-if="perm.url && perm.enabled")
    .recurso
      img.benefit-ok(src="/static/check-green.png")
      div
        span(v-if="perm.front_name") {{perm.front_name}}
        span(v-if="!perm.front_name") {{perm.name}}

  .recurso-outer(:href="perm.url" v-if="perm.url && !perm.enabled")
    .recurso
      img.benefit-nok(src="/static/check-red.png")
      div
        span(v-if="perm.front_name") {{perm.front_name}}
        span(v-if="!perm.front_name") {{perm.name}}

  .recurso-outer(v-if="!perm.url")
    .recurso
      img.benefit-ok(src="/static/check-green.png" v-if="perm.enabled")
      img.benefit-nok(src="/static/check-red.png" v-if="!perm.enabled")
      div
        span(v-if="perm.front_name") {{perm.front_name}}
        span(v-if="!perm.front_name") {{perm.name}}
</template>

<script type="text/javascript">

export default {
  name: "BenefitsPackItem",
  props: ["perm", "group"],
  data() {
    return {
    }
  },
  created() {
  }
}
</script>

<style scoped lang="scss">

@import "./../../variables";
@import "BenefitsPack";

</style>



// WEBPACK FOOTER //
// src/components/benefits/BenefitsPackItem.vue